import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import NotarySection from 'modules/_shared/components/NotarySection';
import InputDate from 'modules/_shared/components/InputDate';
import InputTextArea from 'modules/_shared/components/InputTextArea';
import UploadDocument from 'modules/documents/components/UploadDocument';

import { useSharesTransferModal } from '../context/SharesTransferModalContext';

const SharesTransferScriptureView: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useSharesTransferModal();

  return (
    <>
      <InputDate
        id="date"
        label={t('Date')}
        value={data.date || ''}
        onChange={actions.handleChangeDate}
        minDate={data.lastOperationDate}
        errorMessageKey="InvalidOperationDate"
        required
        lgSize
      />

      <UploadDocument
        label="AddDocumentOptional"
        inputLabel={data.file?.name || t('DragDocumentToUpload')}
        file={data.file}
        setFile={actions.handleChangeFile}
      />

      <InputTextArea
        id="comments"
        label={t('CommentsLabel')}
        value={data.comments}
        onChange={actions.handleChangeComments}
        noResize
      />

      <div className="row mb-4">
        <NotarySection
          notaryName={data.notaryName}
          onChangeName={actions.onChangeNotaryName}
          notaryProtocol={data.notaryProtocol}
          onChangeProtocol={actions.onChangeNotaryProtocol}
          notaryCity={data.notaryCity}
          onChangeCity={actions.onChangeNotaryCity}
          lgSize
        />
      </div>
    </>
  );
};

export default SharesTransferScriptureView;
